import {
  CellModel,
  SpreadsheetComponent
} from '@syncfusion/ej2-react-spreadsheet';
import { IRFP_Context } from '../../../lib/models/interfaces';

const regex = /<<cid:([A-Fa-f0-9]{24})>>/g;

export function saveSpreadsheet(
  ref: React.RefObject<SpreadsheetComponent>,
  fileName: string
) {
  console.log('current ref', ref.current);
  ref.current?.save({
    saveType: 'Xlsx',
    fileName
  });
}

export const getRangeAndCells = (value: string) => {
  const re = /^([A-Za-z]+)(\d+):([A-Za-z]+)(\d+)$/;
  const m = re.exec(value);
  if (m) {
    const [, startCol, startRow, endCol, endRow] = m;
    console.log({ startCol, startRow, endCol, endRow });
    // → { startCol: "A", startRow: "2", endCol: "A", endRow: "20" }
    return { startCol, startRow, endCol, endRow };
  } else {
    return null;
  }
};

export const sanitizeAnswerText = (answerText: string) => {
  // console.log("in sanitise", answerText);
  if (!answerText) return '';
  const parts = answerText.split(/(‹[^›]*›)/g);
  // console.log('parts', parts);
  // const regex = /‹[a-f0-9]{24}›/;
  const result = parts.filter((str) => !regex.test(str)).join('');
  return result;
};

export const getCellValue = (cell: Map<string, CellModel>) => {
  if (!cell) return '';
  const firstKey = [...cell.keys()][0];
  return cell.get(firstKey)?.value ?? '';
};

export const groupAdjacentCells = (cells: Set<string>): string[] => {
  console.log('cells input', cells);
  if (cells.size === 0) return [];

  // Convert to array and sort by row number
  const sorted = [...cells].sort((a, b) => {
    const numA = parseInt(a.slice(1), 10);
    const numB = parseInt(b.slice(1), 10);
    return numA - numB;
  });

  const ranges: string[] = [];
  let start = sorted[0];
  let prev = sorted[0];

  for (let i = 1; i < sorted.length; i++) {
    const current = sorted[i];
    const prevNum = parseInt(prev.slice(1), 10);
    const currentNum = parseInt(current.slice(1), 10);

    if (currentNum === prevNum + 1) {
      // Still contiguous
      prev = current;
    } else {
      // Break in sequence — push current range
      if (start === prev) {
        ranges.push(start);
      } else {
        ranges.push(`${start}:${prev}`);
      }
      start = current;
      prev = current;
    }
  }

  // Push the last range
  if (start === prev) {
    ranges.push(start);
  } else {
    ranges.push(`${start}:${prev}`);
  }

  return ranges;
};

export const getAddedRows = (start: string, end: string): string[] => {
  // Support any column length (e.g., A, ZZ, AAA) and any row number (e.g., 1, 99999).
  const startCol = start.match(/^[A-Za-z]+/)![0];
  const endCol = end.match(/^[A-Za-z]+/)![0];
  const startNum = parseInt(start.match(/\d+$/)![0], 10);
  const endNum = parseInt(end.match(/\d+$/)![0], 10);

  // Support any column length (e.g., A, ZZ, AAA) and any row number (e.g., 1, 99999).
  // If columns differ, enforce same-column ranges for now.
  if (startCol !== endCol) {
    return [];
  }

  // Allow reversed ranges like AAA1000:AAA999 by swapping
  const sNum = Math.min(startNum, endNum);
  const eNum = Math.max(startNum, endNum);

  const result: string[] = [];
  for (let i = sNum; i <= eNum; i++) {
    result.push(`${startCol}${i}`);
  }
  return result;
};

export const replaceColumnInRanges = (
  ranges: string[],
  newColumn: string
): string[] => {
  return ranges.map((range) => {
    return range
      .split(':')
      .map((cell) => {
        const rowNum = cell.match(/\d+$/)?.[0] ?? '';
        return `${newColumn}${rowNum}`;
      })
      .join(':');
  });
};

export async function hash(obj: any) {
  const msgBuffer = new TextEncoder().encode(JSON.stringify(obj));
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const getColumnValue = (cell: string) => {
  const match = cell.match(/^[A-Za-z]+/);
  return match ? match[0] : '';
};

// export const getCitationsString = (text: string): string[] => {
//   const regex = /‹(.*?)›/g;
//   const matches: string[] = [];
//   let match;

//   while ((match = regex.exec(text)) !== null) {
//     // console.log("text ids function", match);
//     matches.push(match[1]);
//   }

//   return matches;
// };

export const getIdsFromText = (text: string): string[] => {
  // const regex = /‹(.*?)›/g;
  // const regex = /<<cid:([A-Fa-f0-9]{24})>>/g;
  const matches: string[] = [];
  let match;
  console.log('textMatch', text);
  while ((match = regex.exec(text)) !== null) {
    console.log('text ids function', match);
    matches.push(match[1]);
  }
  console.log('textMatch matches', matches);
  return matches;
};

export const createCitationInfo = (
  text: string,
  contextArray: IRFP_Context[]
) => {
  let localCite: { [key: string]: number };
  console.log('incoming text', text);
  const idsWithIndex = getIdsFromText(text);
  console.log('ids with index', idsWithIndex);
  localCite = {} as { [key: string]: number };
  let count = 1;
  idsWithIndex.forEach((ele, index) => {
    if (localCite) {
      if (!localCite[ele]) {
        localCite[ele] = count;
        count++;
      }
    }
  });
  const citationArray: string[] = [];
  const seenCitationSet: Set<string> = new Set();
  const replacedHtml = text.replace(
    // /‹([^›]*)›/g,
    regex,
    // citeRegex,
    (_, citationId) => {
      // console.log('citation id in replace', citationId);
      const citationLabel = localCite![`${citationId}`];
      const citeInfo = contextArray?.filter((ele) => ele._id === citationId)[0];
      console.log('citeInfo', citeInfo);
      if (!seenCitationSet.has(citeInfo?._id)) {
        citationArray.push(
          `<p><span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}">&lt;${citationLabel}&gt;</span>&nbsp;${citeInfo?.Document?.documentFileName}&nbsp;(Pg:&nbsp;${citeInfo?.PageNumber ?? citeInfo?.pageNumber})</p>`
        );
        seenCitationSet.add(citeInfo?._id);
      }
      return `<span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}">&lt;${citationLabel}&gt;</span>`;
    }
  );
  console.log('localCite', localCite);
  console.log('replACEDHTML', replacedHtml);
  return {
    originalInternalAnswer: replacedHtml,
    allCitationIds: Array.from(seenCitationSet),
    citationArray
  };
};
